(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ──────────────────────────────────────────────
     Countdown timers
     ────────────────────────────────────────────── */
  document.querySelectorAll('.ld-timer[data-end]').forEach(function (el) {
    var endTime = new Date(el.dataset.end).getTime();
    var textEl = el.querySelector('.ld-timer__text');
    if (!textEl || isNaN(endTime)) return;

    var card = el.closest('.ld-card');
    var dealLabel = card ? card.querySelector('.ld-card__deal-label') : null;

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        if (card) card.style.display = 'none';
        return;
      }
      if (dealLabel) {
        if (diff <= 6 * 3600 * 1000) {
          dealLabel.style.display = 'block';
          dealLabel.textContent = 'Deal expires soon!';
        } else {
          dealLabel.style.display = 'none';
        }
      }
      if (diff > 24 * 3600 * 1000) {
        el.style.backgroundColor = '#06951D';
      } else if (diff >= 8 * 3600 * 1000) {
        el.style.backgroundColor = '#EE5300';
      } else {
        el.style.backgroundColor = '#EB1E27';
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      textEl.textContent =
        String(h).padStart(2, '0') + 'h : ' +
        String(m).padStart(2, '0') + 'm : ' +
        String(s).padStart(2, '0') + 's';
      setTimeout(tick, 1000);
    }
    tick();
  });

  /* ──────────────────────────────────────────────
     AJAX Add to Cart
     ────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ld-card__form');
    if (!form) return;

    e.preventDefault();
    handleAddToCart(form);
  });

  function handleAddToCart(form) {
    var btn = form.querySelector('.ld-card__atc');
    if (!btn || btn.dataset.loading === 'true') return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!idInput) return;

    var originalHTML = btn.innerHTML;

    btn.dataset.loading = 'true';
    btn.disabled = true;
    btn.classList.add('ld-card__atc--loading');
    btn.innerHTML = 'ADDING…';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(idInput.value),
            quantity: Number((qtyInput && qtyInput.value) || 1)
          }
        ]
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showError(btn, originalHTML, result.data && result.data.description);
          return;
        }
        return refreshCart().then(function () {
          showSuccess(btn, originalHTML);
        });
      })
      .catch(function (err) {
        console.error('[Lightning Deals] Add to cart failed:', err);
        resetBtn(btn, originalHTML);
      });
  }

  function showSuccess(btn, originalHTML) {
    btn.classList.remove('ld-card__atc--loading');
    btn.classList.add('ld-card__atc--added');
    btn.innerHTML = '✓ ADDED';
    setTimeout(function () {
      btn.classList.remove('ld-card__atc--added');
      resetBtn(btn, originalHTML);
    }, 1800);
  }

  // Backstop only — syncStockButtons() (below) disables the button up front
  // whenever the cart already holds the tracked stock limit, so this path
  // should now be rare (e.g. two tabs open, stock sold out to someone else
  // between page load and click). Rather than cramming Shopify's often-long
  // rejection message into the button itself (which used to visibly distort
  // the button), it's shown as a centered modal alert, and the button is
  // immediately resynced against the cart instead of just reverting to a
  // live-looking button that would fail again on the next click.
  function showError(btn, originalHTML, message) {
    btn.classList.remove('ld-card__atc--loading');
    showStockAlert(message || 'This item is unavailable in the requested quantity.');
    resetBtn(btn, originalHTML);
    syncStockButtons();
  }

  /* ──────────────────────────────────────────────
     Stock warning alert
     Same centered-overlay-modal treatment as the cart page's remove
     confirmation (oxygen-cart-items.liquid's showRemoveConfirm) rather
     than a small corner toast, so a rejected add is hard to miss. Built
     once and reused (single overlay node), auto-dismisses, but can also
     be dismissed via the OK button, clicking the overlay, or Escape.
     ────────────────────────────────────────────── */
  var stockAlertHideTimer = null;

  function showStockAlert(message) {
    var overlay = document.getElementById('ld-stock-alert-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'ld-stock-alert-overlay';
      overlay.className = 'ld-stock-alert-overlay';
      overlay.innerHTML =
        '<div class="ld-stock-alert-box" role="alertdialog" aria-modal="true">' +
          '<p class="ld-stock-alert-text"></p>' +
          '<button type="button" class="ld-stock-alert-ok">OK</button>' +
        '</div>';
      document.body.appendChild(overlay);
    }

    overlay.querySelector('.ld-stock-alert-text').textContent = message;
    overlay.classList.add('is-open');

    var okBtn = overlay.querySelector('.ld-stock-alert-ok');

    function close() {
      overlay.classList.remove('is-open');
      clearTimeout(stockAlertHideTimer);
      okBtn.removeEventListener('click', close);
      overlay.removeEventListener('click', onOverlayClick);
      document.removeEventListener('keydown', onKeydown);
    }
    function onOverlayClick(e) {
      if (e.target === overlay) close();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    okBtn.addEventListener('click', close);
    overlay.addEventListener('click', onOverlayClick);
    document.addEventListener('keydown', onKeydown);

    clearTimeout(stockAlertHideTimer);
    stockAlertHideTimer = setTimeout(close, 4000);
  }

  function resetBtn(btn, originalHTML) {
    btn.innerHTML = originalHTML;
    btn.classList.remove('ld-card__atc--loading');
    btn.disabled = false;
    btn.dataset.loading = 'false';
  }

  /* ──────────────────────────────────────────────
     Refresh cart drawer / header badge
     ────────────────────────────────────────────── */
  function refreshCart() {
    var drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    if (drawer && typeof drawer.renderContents === 'function') {
      var sections =
        typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender().map(function (s) { return s.id; })
          : ['cart-drawer', 'cart-icon-bubble'];

      return fetch(ROOT + '?sections=' + sections.join(','))
        .then(function (r) { return r.json(); })
        .then(function (sectionsData) {
          if (drawer.classList) drawer.classList.remove('is-empty');
          drawer.renderContents({ sections: sectionsData });
          if (typeof drawer.open === 'function') drawer.open();
          return genericRefresh();
        })
        .catch(function () { return genericRefresh(); });
    }

    return genericRefresh();
  }

  function genericRefresh() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadges(cart.item_count);
        return dispatchCartEvent(cart);
      })
      .catch(function () { /* silent */ });
  }

  function updateCartBadges(count) {
    /* Custom SW header badge */
    document.querySelectorAll('[data-badge="cart"]').forEach(function (badge) {
      badge.textContent = count;
      if (count > 0) {
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    });

    /* Dawn-style bubble, if present */
    document
      .querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]')
      .forEach(function (el) {
        el.textContent = count;
      });
  }

  function dispatchCartEvent(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true })
    );
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    /* Dawn pub/sub — lets other components react */
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'lightning-deals',
        cartData: cart
      });
    }
    return cart;
  }

  /* ──────────────────────────────────────────────
     Stock-vs-cart sync
     Disables an ATC button up front when the visitor's cart already
     holds as much of that variant as is in stock, instead of letting
     them click into a guaranteed 422 (see showError() above). Mirrors
     syncWishlistButtons() below: run once on load, then re-run any
     time the cart changes so removing the item (cart drawer, another
     section) re-enables the button without a reload.
     ────────────────────────────────────────────── */
  function syncStockButtons(cart) {
    var forms = document.querySelectorAll('.ld-card__form[data-inventory-policy]');
    if (!forms.length) return Promise.resolve();

    var cartPromise = cart
      ? Promise.resolve(cart)
      : fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });

    return cartPromise
      .then(function (cartData) {
        var lines = (cartData && cartData.items) || [];

        forms.forEach(function (form) {
          var btn = form.querySelector('[data-ld-atc-btn]');
          var idInput = form.querySelector('input[name="id"]');
          // Don't fight a request that's currently in flight.
          if (!btn || !idInput || btn.dataset.loading === 'true') return;

          var management = form.dataset.inventoryManagement;
          var policy = form.dataset.inventoryPolicy;
          var stock = Number(form.dataset.inventoryQuantity);

          // Untracked inventory or "continue selling" policy: no real
          // ceiling to enforce here, leave the button alone.
          if (!management || policy !== 'deny' || isNaN(stock)) {
            setMaxInCart(btn, false);
            return;
          }

          var variantId = Number(idInput.value);
          var line = lines.filter(function (li) {
            return li.variant_id === variantId;
          })[0];
          var cartQty = line ? line.quantity : 0;

          setMaxInCart(btn, cartQty >= stock);
        });
      })
      .catch(function () {
        /* silent — leave buttons as server-rendered */
      });
  }

  function setMaxInCart(btn, isMax) {
    if (isMax) {
      if (btn.dataset.maxInCart === 'true') return;
      btn.dataset.maxInCart = 'true';
      btn.dataset.originalHtml = btn.dataset.originalHtml || btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('ld-card__atc--sold-out');
      btn.innerHTML = 'MAX IN CART';
    } else {
      if (btn.dataset.maxInCart !== 'true') return;
      btn.dataset.maxInCart = 'false';
      btn.disabled = false;
      btn.classList.remove('ld-card__atc--sold-out');
      if (btn.dataset.originalHtml) btn.innerHTML = btn.dataset.originalHtml;
    }
  }

  syncStockButtons();

  // Covers cart changes from anywhere: this section's own successful add
  // (dispatchCartEvent fires this already), the cart drawer, or another
  // section on the page — so a removal re-enables the button live.
  document.addEventListener('cart:updated', function (e) {
    syncStockButtons(e.detail && e.detail.cart);
  });

  /* ──────────────────────────────────────────────
     Wishlist — localStorage key: 'sw-wishlist'
     Stores an ARRAY OF PRODUCT HANDLES, matching the
     Wishlist Page section and header badge.
     ────────────────────────────────────────────── */
  var WISHLIST_KEY = 'sw-wishlist';

  function getWishlist() {
    try {
      var list = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      if (!Array.isArray(list)) return [];
      /* Guard against legacy object entries — keep only handle strings */
      return list.filter(function (item) {
        return typeof item === 'string' && item.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent('sw:wishlist:updated', { detail: { list: list } }));
  }

  function syncWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('.ld-wishlist').forEach(function (btn) {
      var active = list.indexOf(btn.dataset.productHandle) !== -1;
      btn.classList.toggle('ld-wishlist--active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ld-wishlist');
    if (!btn) return;

    e.preventDefault();

    var handle = btn.dataset.productHandle;
    if (!handle) return;

    var list = getWishlist();
    var idx = list.indexOf(handle);

    if (idx !== -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }

    saveWishlist(list);
    syncWishlistButtons();
  });

  syncWishlistButtons();

  window.addEventListener('storage', function (e) {
    if (e.key === WISHLIST_KEY) syncWishlistButtons();
  });
})();
